import React from 'react';
import { Trophy, Star, Clock, Award, ArrowUpRight } from 'lucide-react';
import { siteConfig, freelancerStats } from '../data/mock';

const StatsStrip = () => {
  const tiles = [
    { id: 'rank', big: freelancerStats.rank, label: freelancerStats.rankOf, sub: 'Freelancer.com', icon: Trophy, accent: 'text-green' },
    { id: 'rating', big: freelancerStats.rating, label: `${freelancerStats.reviews} client reviews`, sub: 'Average rating', icon: Star, accent: 'text-amber' },
    { id: 'ontime', big: freelancerStats.onTime, label: 'On time · on budget', sub: 'Every project', icon: Clock, accent: 'text-blue' },
    { id: 'years', big: freelancerStats.years, label: 'Years in email outreach', sub: 'Since 2017', icon: Award, accent: 'text-ink' }
  ];

  return (
    <section className="relative -mt-6 pb-8" data-testid="stats-strip">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="window" data-reveal>
          <div className="window-bar">
            <span className="window-dot" /><span className="window-dot" /><span className="window-dot" />
            <span className="ml-3 font-mono text-[11px] text-slate-2 tracking-wider">SENDER REPUTATION · LIVE</span>
            <a href={siteConfig.freelancerProfile} target="_blank" rel="noopener noreferrer" className="ml-auto flex items-center gap-2 text-xs font-medium text-slate hover:text-ink" data-testid="stats-freelancer-link">
              <img src={freelancerStats.preferredBadge} alt="Preferred Freelancer" className="h-5" />
              <span className="hidden sm:inline">Verified on Freelancer.com</span>
              <ArrowUpRight className="w-3.5 h-3.5" />
            </a>
          </div>
          <div className="grid grid-cols-2 lg:grid-cols-4 divide-x divide-y lg:divide-y-0 divide-[#E2E8F0]">
            {tiles.map((t) => (
              <div key={t.id} className="p-5 sm:p-7 flex flex-col gap-3" data-testid={`stat-${t.id}`}>
                <div className="flex items-center justify-between">
                  <span className="font-mono text-[10px] uppercase tracking-widest text-slate-2">{t.sub}</span>
                  <t.icon className={`w-4 h-4 ${t.accent}`} />
                </div>
                <p className="font-display text-3xl sm:text-4xl font-extrabold text-ink leading-none">{t.big}</p>
                <p className="text-sm text-slate">{t.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default StatsStrip;
